import { fromJS } from 'immutable';
import * as actionTypes from '../actions/umoUtilsActionTypes';

const initialState = fromJS({
  emailRequest: null,
  resizeRequest: null,
  modifyRequest: null,
  downloadOptions: null,
  downloadUsageFields: null,
});

const umoUtils = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UMO_UTILS_EMAIL_REQUEST: {
      const requestData = fromJS(action).remove('type');
      return state.set('emailRequest', requestData);
    }
    case actionTypes.UMO_UTILS_EMAIL_SUCCESS:
      return state.set('emailRequest', true);
    case actionTypes.UMO_UTILS_EMAIL_FAILURE:
      return state.set('emailRequest', action.error);
    case actionTypes.UMO_UTILS_EMAIL_DISMISS:
      return state.set('emailRequest', null);
    case actionTypes.UMO_UTILS_MANIPULATION_REQUEST:
      return state.set('modifyRequest', action.requestPromise);
    case actionTypes.UMO_UTILS_MANIPULATION_SUCCESS:
      return state.set('modifyRequest', null);
    case actionTypes.UMO_UTILS_MANIPULATION_FAILURE:
      return state.set('modifyRequest', action.err);
    case actionTypes.WORKSPACE_DOWNLOAD_OPTIONS_SUCCESS:
      return state.set('downloadOptions', action.downloadOptions);
    case actionTypes.UMO_DOWNLOAD_USAGE_FAILURE:
      return state.set('downloadUsageFields', null);
    case actionTypes.UMO_DOWNLOAD_USAGE_SUCCESS:
      return state.set('downloadUsageFields', action.downloadUsageFields);
    default:
      return state;
  }
};

export default umoUtils;
